import React, { FC } from 'react'
import ProductCard, { ProductCardVariant } from '@components/ProductCard'

type Props = {
  variant: ProductCardVariant
  limit?: number
}

const LoadingCards: FC<Props> = ({ variant, limit = 24 }) => {
  return (
    <>
      {[...Array.from(new Array(limit))].map((_, i) => (
        <ProductCard key={`loading-card-${i}`} variant={variant} isLoading />
      ))}
    </>
  )
}

export default LoadingCards
